import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import GeoMapper from '@/playground/geomapper/GeoMapper.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/geomapper',
        name: 'GeoMapper',
        component: GeoMapper
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
